import React, { memo } from 'react'

const EmptyFiltersValues = () => {
  return (
    <div className="empty_filters_values">
      <span className="main_text">
        Apply filters above to connect device to channels{' '}
      </span>
      <span className="sub_text">
        You need to clearly select the location, panel and meter to link devices
        to channels
      </span>
    </div>
  )
}

export default memo(EmptyFiltersValues)
